import React from 'react';

//
import MainTitle from '../../components/page/main-title/MainTitle';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import './page.css';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import View from './View';

const URL_PLANO_ALIMENTAR = WS.planos_alimentares.detalhe;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false
    };

  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);


    Requisitions({
      url:URL_PLANO_ALIMENTAR,
      data: window.dadosUser,
      sucess:function(data){
        const doc = new DOMParser().parseFromString(data, 'text/html');
        const body = doc.getElementById('loader');

        document.getElementById("box-iframe").appendChild(body);
      },
      error:function(data){

      }
    });
  }

  render() {
    const view = this.state.loaded ? this.getView() : null;
    return (
      <div className="page-dashboard page-content" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner" id="box-iframe">
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/meu-plano-alimentar/Page.js